var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgScallopTag = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m65.98 36.31-1.26-.79.7-1.31c1.52-2.84-.47-6.29-3.69-6.4l-1.49-.05-.05-1.49c-.11-3.22-3.56-5.21-6.4-3.69l-1.31.7-.79-1.26c-1.7-2.74-5.69-2.74-7.39 0l-.79 1.26-1.31-.7c-2.84-1.52-6.29.47-6.4 3.69l-.05 1.49-1.49.05c-3.22.11-5.21 3.56-3.69 6.4l.7 1.31-1.26.79c-2.74 1.7-2.74 5.69 0 7.39l1.26.79-.7 1.31c-1.52 2.84.47 6.29 3.69 6.4l1.49.05.05 1.49c.11 3.22 3.56 5.21 6.4 3.69l1.31-.7.79 1.26c1.7 2.74 5.69 2.74 7.39 0l.79-1.26 1.31.7c2.84 1.52 6.29-.47 6.4-3.69l.05-1.49 1.49-.05c3.22-.11 5.21-3.56 3.69-6.4l-.7-1.31 1.26-.79c2.74-1.7 2.74-5.69 0-7.39ZM48 29.36a2.69 2.69 0 1 1 .002-5.382A2.69 2.69 0 0 1 48 29.36Z"
  })));
};
export default SvgScallopTag;